import { useState, useEffect } from 'react';

const STORAGE_KEY = 'optika-install-dismissed';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible]               = useState(false);

  useEffect(() => {
    // Never show inside the Electron desktop app or if already dismissed
    if (window.electronAPI?.isDesktop) return;
    if (localStorage.getItem(STORAGE_KEY)) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      localStorage.setItem(STORAGE_KEY, '1');
    }
    setVisible(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position:       'fixed',
      bottom:         16,
      left:           16,
      right:          16,
      zIndex:         9998,
      background:     '#1E3A5F',
      color:          '#F1F5F9',
      borderRadius:   12,
      padding:        '14px 16px',
      display:        'flex',
      alignItems:     'center',
      gap:            12,
      boxShadow:      '0 8px 32px rgba(0,0,0,0.28)',
      border:         '1px solid #2563EB44',
    }}>
      {/* Icon */}
      <div style={{ width: 40, height: 40, borderRadius: 10, background: '#2563EB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', flexShrink: 0 }}>
        📱
      </div>

      {/* Text */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: '0.85rem', marginBottom: 2 }}>Install OptiKa</div>
        <div style={{ fontSize: '0.75rem', color: '#93C5FD', lineHeight: 1.4 }}>
          Add to your home screen for quick access
        </div>
      </div>

      {/* Buttons */}
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button
          onClick={handleDismiss}
          style={{ background: 'transparent', border: '1px solid #334155', color: '#94A3B8', borderRadius: 7, padding: '6px 12px', fontSize: '0.78rem', cursor: 'pointer' }}
        >
          Not now
        </button>
        <button
          onClick={handleInstall}
          style={{ background: '#2563EB', border: 'none', color: '#fff', borderRadius: 7, padding: '6px 14px', fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer' }}
        >
          Install
        </button>
      </div>
    </div>
  );
}
